export class UpdateRolesInfo {
    // same class in prov-model
    public SubKey: string;
    public Level: string;
    public AccountName: string;
    public AccountDoingAction: string;
    public UpdateRoles: UpdateRoles[];

    constructor() {}

    assign(subKey: string, level: string, accountName: string, accountDoingAction: string, updateRoles: UpdateRoles[]) {
        this.SubKey = subKey;
        this.Level = level;
        this.AccountName = accountName;
        this.AccountDoingAction = accountDoingAction;
        this.UpdateRoles = updateRoles;
    }
}

// usata anche in cloud-console
export class UpdateRoles {
    public RoleName: string;
    public Description: string;
    public Value: boolean;
    public IsModified: boolean;
    public AccountName: string;
    public Weight: number;

    // constructor() {}

    // assign(updateRoles?: UpdateRoles) {
    //     return Object.assign(updateRoles);
    // }
}
